import script from "./mHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./mHeader.vue?vue&type=script&setup=true&lang=js"

import "./mHeader.vue?vue&type=style&index=0&id=e8c5edd8&lang=scss"
import "./mHeader.vue?vue&type=style&index=1&id=e8c5edd8&lang=scss&scoped=true"

import exportComponent from "E:\\xm\\siggraph\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8c5edd8"]])

export default __exports__